module.exports = __webpack_public_path__ + "img/icon31.1e954838.png";